import { Controller } from "react-hook-form";
import InputMask from "react-input-mask";

const PhoneInput = ({ label, required, error, name, control, className }) => {
  return (
    <>
      <div className={`${className} w-full relative`}>
        <Controller
          name={name}
          control={control}
          rules={{ required }}
          render={({ field }) => (
            <InputMask
              {...field}
              id={name}
              mask="(99) 99999-9999"
              maskChar=""
              className={`block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-300 appearance-none dark:text-white dark:border-gray-600 focus:outline-none focus:ring-0 peer ${
                error ? "border-red-500" : "focus:border-blue-600"
              }`}
              placeholder=""
            />
          )}
        />
        <label
          htmlFor={name}
          className="absolute text-md text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
        >
          {label}
        </label>
      </div>
      {error && (
        <small className="text-red-400">
          {error.message || "Campo obrigatório"}
        </small>
      )}
    </>
  );
};

export default PhoneInput;
